import { useEffect, useState } from "react";
import AdminLayout from "@/components/layout/AdminLayout";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";

export default function AdminCustomers() {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/admin/customers").then((r) => setUsers(r.data)).catch(() => {}); }, []);
  const filtered = users.filter((u) => `${u.name} ${u.email} ${u.phone}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div className="flex items-center justify-between gap-4">
          <div>
            <div className="text-xs uppercase tracking-widest text-primary font-semibold">Customers</div>
            <h1 className="font-display text-3xl mt-2">Customer management</h1>
          </div>
          <Input placeholder="Search…" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-xs" data-testid="admin-cust-search" />
        </div>
        <Card className="p-0 overflow-hidden">
          <Table>
            <TableHeader><TableRow><TableHead>Name</TableHead><TableHead>Email</TableHead><TableHead>Phone</TableHead><TableHead>KYC</TableHead><TableHead>Joined</TableHead></TableRow></TableHeader>
            <TableBody>
              {filtered.map((u) => (
                <TableRow key={u.id}>
                  <TableCell>{u.name}</TableCell>
                  <TableCell>{u.email}</TableCell>
                  <TableCell>{u.phone || "—"}</TableCell>
                  <TableCell><span className={`text-xs px-2 py-1 rounded-full ${u.kyc_status === "verified" ? "bg-emerald-500/10 text-emerald-600" : "bg-muted"}`}>{u.kyc_status}</span></TableCell>
                  <TableCell>{u.created_at ? new Date(u.created_at).toLocaleDateString() : "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      </div>
    </AdminLayout>
  );
}
